var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vcv-progress",class:[`vcv-progress--${_vm.color}`]},[_c('div',{staticClass:"vcv-progress__value",style:({ width: _vm.value + '%' })}),_vm._v(" "),_c('div',{staticClass:"vcv-progress__test"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }